export const CHAT_EXERCISE = 'ChatExercise';
export const EXPORTED_EXERCISES = [CHAT_EXERCISE];